import { render, staticRenderFns } from "./HistoryOverlay.vue?vue&type=template&id=bedcc3ec&"
import script from "./HistoryOverlay.vue?vue&type=script&lang=js&"
export * from "./HistoryOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports